import { VApp } from 'vuetify/lib/components/VApp';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VMain } from 'vuetify/lib/components/VMain';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$route.meta.allowAnonymous)?[_c(VApp,[_c('div',{staticClass:"app-container"},[_c('top-toolbar'),_c('top-navigation'),_c(VMain,[_c(VContainer,{attrs:{"fluid":""}},[_c('router-view')],1)],1)],1)])]:[_c('router-view')],(_vm.$store.getters.getShowPlaylistDialog)?_c('add-play-list-dlg'):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }